import React, { useContext } from 'react'
import classNames from 'classnames'
import Image from '@toasttab/shared/src/components/atoms/Image/Image'
import Eyebrow from '@toasttab/shared/src/components/molecules/Eyebrow/Eyebrow'
import Description from '@toasttab/shared/src/components/atoms/Description/Description'
import { Button } from '@toasttab/shared/src/components'
import { OTLContext } from '@toasttab/shared/src/context/OTLContext'
import { getImage } from '@toasttab/shared/src/utils/siteUtils'
import { resolvePrefix } from '@toasttab/shared/src/utils/assetUtils'
import { TechTipProps } from './TechTips.d'

const TechTipModule = ({
  tipBody,
  tipBodyUpsell,
  hideCtaDownloadIcon,
  tipCtaImage,
  tipCtaImageUpsell,
  tipCtaLabel,
  tipCtaLabelUpsell,
  tipCtaLink,
  tipCtaLinkUpsell,
  tipKicker,
  tipKickerUpsell
}: TechTipProps) => {
  const params = new URLSearchParams(
    typeof window !== 'undefined' && window?.location.search
  )
  const isCustomer = params.get('customer')
  const otlParams = useContext(OTLContext)
  const OTLArticleUX: boolean = Boolean(otlParams.isArticle)

  const blockLabel = 'Tech Tip'
  const blockIcon = {
    position: 'left',
    width: '14',
    height: '14',
    src: resolvePrefix('/img-toast-logo-mark.svg')
  }

  let body = tipBody
  let ctaImage = [getImage(tipCtaImage)]
  let ctaLink = tipCtaLink
  let ctaLabel = tipCtaLabel
  let kicker = tipKicker

  if (isCustomer === 'true') {
    body = tipBodyUpsell || tipBody
    ctaImage = tipCtaImageUpsell
      ? [getImage(tipCtaImageUpsell)]
      : [getImage(tipCtaImage)]
    ctaLink = tipCtaLinkUpsell || tipCtaLink
    ctaLabel = tipCtaLabelUpsell || tipCtaLabel
    kicker = tipKickerUpsell || tipKicker
  }

  const sectionCss = classNames('block md:flex items-start', {
    'otl-techtips mt-7 bg-otl-tan-dark': !OTLArticleUX,
    'bg-white rounded-lg shadow-lg': OTLArticleUX
  })

  const mediaContainerCss = classNames(
    'relative p-5 pb-0 md:p-0 md:pl-7 justify-center flex self-stretch items-center',
    'min-w-0 max-w-none md:min-w-[225px] md:max-w-[225px]',
    'before:content-[""] before:absolute before:left-0 before:top-0',
    {
      'before:bg-center before:w-full before:h-1/2 md:before:w-1/2 md:before:h-full before:bg-img-otl-techtips':
        !OTLArticleUX,
      'before:bg-brand-50 before:w-full md:before:w-[118px] before:h-2 md:before:h-full  before:rounded-t-lg md:before:rounded-b-lg md:before:bg-no-repeat md:before:bg-[length:50%_100%] md:before:bg-img-otl-techtips-lines':
        OTLArticleUX
    }
  )

  const contentContainerCss = classNames('py-5 md:py-10 pl-5 pr-7', {
    'my-3': !OTLArticleUX
  })

  const descriptionCss = classNames('pb-3', {
    'text-[1.25rem] leading-[24px] font-sansPro': OTLArticleUX
  })

  return (
    <section className={sectionCss}>
      <div className={mediaContainerCss}>
        <Image
          classes={
            OTLArticleUX &&
            '!w-[calc(100%_+_40rem)] h-[181px] md:w-full -ml-[20px] -mr-[20px] -top-3 md:top-0 md:ml-0 md:mr-0 md:rounded-lg !mb-0'
          }
          url={ctaImage[0].url}
          optimizedImages={ctaImage[0].optimizedImages}
        />
      </div>
      <div className={contentContainerCss}>
        {OTLArticleUX && (
          <img
            alt='Toast'
            className='h-[16px] mb-4'
            src={resolvePrefix('/svg/img-toast-logo.svg')}
          />
        )}
        {kicker && (
          <img src={resolvePrefix('/svg/img-toast-logo.svg')} alt='Toast' />
        )}
        {!kicker && !OTLArticleUX && (
          <Eyebrow icon={blockIcon} variation='otl-grey' link={undefined}>
            {blockLabel}
          </Eyebrow>
        )}
        <Description classes={descriptionCss}>{body}</Description>
        <Button
          href={ctaLink}
          fontWeight={['font-semibold']}
          classes={!OTLArticleUX ? 'uppercase' : ''}
          download={!hideCtaDownloadIcon}
          arrowHover={!hideCtaDownloadIcon}
        >
          {ctaLabel}
        </Button>
      </div>
    </section>
  )
}

export default TechTipModule
